export default "__VITE_ASSET__BFBt5MO___"